define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/SettingsModel", "../../models/AcrobitsAccountModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, SettingsModel, AcrobitsAccountModel, UserContext) {
    "use strict";
    var CompanySettings = /** @class */ (function () {
        function CompanySettings() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,CompanySettings.Edit,CompanySettings.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,CompanySettings.Delete"));
            this.editModel = ko.observable(new SettingsModel());
            this.editAcrobitsAccountModel = ko.observable(new AcrobitsAccountModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        CompanySettings.prototype.init = function () {
            var self = this;
            $("#page-title").text("Company Settings");
            tools.ajaxGet({
                url: "/CompanySettings/GetCompanySettingsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    self.initSettings(self.lookupLists.GridStructures.SettingsStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CompanySettings.prototype.initSettings = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "150px",
                sortable: false,
                template: function () {
                    var html = '';
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" title="Edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    return html;
                }
            });
            var gridId = "settingsTable";
            self.settingsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    toolbar: kendo.template($("#settings-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CompanySettings/GetCompanySettings",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "Settings",
                    title: "Settings",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.settingsTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.settingsTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editSetting(data.Id);
                event.preventDefault();
            });
        };
        CompanySettings.prototype.editSetting = function (id) {
            var self = this;
            var title = "Edit Setting";
            self.editModal = tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveSetting(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CompanySettings/GetSettingById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new SettingsModel(result.Data));
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new SettingsModel());
                    }
                    $.when(getModelCall).done(function () {
                        if (self.editModel().InputType() === "AcrobitsAccountInput") {
                            if (self.editModel().Value()) {
                                var accountModel = JSON.parse(self.editModel().Value());
                                accountModel["Id"] = self.editModel().Id();
                                self.editAcrobitsAccountModel(new AcrobitsAccountModel(accountModel));
                            }
                            else {
                                self.editAcrobitsAccountModel(new AcrobitsAccountModel());
                            }
                            $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'acrobits-account-edit-template', data: editAcrobitsAccountModel }\"></div>");
                        }
                        else {
                            $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'setting-edit-template', data: editModel }\"></div>");
                        }
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CompanySettings.prototype.editCustomerSetting = function (id, customerId, globalId, saveCallback) {
            var self = this;
            var title = "Edit Customer Setting";
            self.editModal = tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveSetting(event.currentTarget, modal, saveCallback);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    getModelCall = tools.ajaxGet({
                        url: "/CompanySettings/GetSettingById",
                        data: { id: id, globalId: globalId },
                        success: function (result) {
                            if (result.Success) {
                                self.editModel(new SettingsModel(result.Data));
                                if (!self.editModel().Id() && !self.editModel().CustomerId() && globalId > 0) {
                                    self.editModel().CustomerId(customerId);
                                }
                            }
                        }
                    });
                    $.when(getModelCall).done(function () {
                        if (self.editModel().InputType() === "AcrobitsAccountInput") {
                            if (self.editModel().Value()) {
                                var accountModel = JSON.parse(self.editModel().Value());
                                accountModel["Id"] = self.editModel().Id();
                                accountModel["CustomerId"] = self.editModel().CustomerId();
                                self.editAcrobitsAccountModel(new AcrobitsAccountModel(accountModel));
                            }
                            else {
                                self.editAcrobitsAccountModel(new AcrobitsAccountModel());
                            }
                            $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'acrobits-account-edit-template', data: editAcrobitsAccountModel }\"></div>");
                        }
                        else {
                            $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'setting-edit-template', data: editModel }\"></div>");
                        }
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CompanySettings.prototype.saveSetting = function (btn, modal, cb) {
            var self = this;
            if (self.editModel().InputType() === "AcrobitsAccountInput") {
                var value = tools.modelToJSON(self.editAcrobitsAccountModel);
                self.editModel().Value(value);
            }
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CompanySettings/SaveSetting",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    $(modal).modal("hide");
                    if (cb) {
                        cb(result.Data);
                    }
                    if (self.settingsTable) {
                        self.settingsTable.refresh();
                    }
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CompanySettings.prototype.deleteCustomerSetting = function () {
            var self = this;
            var obj = { id: self.editModel().Id() };
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CompanySettings/DeleteCustomerSetting",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.editModal) {
                        $(self.editModal).modal("hide");
                    }
                    if (self.deleteCustomerCallback) {
                        self.deleteCustomerCallback();
                    }
                    if (self.settingsTable) {
                        self.settingsTable.refresh();
                    }
                }
            }).always(function () {
                //$(btn).button("reset");
            });
        };
        CompanySettings.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        CompanySettings.prototype.exportTo = function () {
            var self = this;
            self.settingsTable.exportTo();
        };
        CompanySettings.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Settings");
                dataLogs.open("Roles logs");
                event.preventDefault();
            }
        };
        return CompanySettings;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CompanySettings/Index")) {
            log.log("Initialize Company settings");
            $(function () {
                (new CompanySettings()).init();
            });
        }
    }, 0);
    return CompanySettings;
});
//# sourceMappingURL=companySettings.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/companySettings.js
// module id = 75
// module chunks = 2